<template>
  <div class="zl-am">
    <vk-modal
      :show="modalAuth.show"
      @hide="hideModals">
      <authentication></authentication>
    </vk-modal>
    <tm-modal
      :show="modal.show"
      :block="modal.block"
      :icon="modal.icon"
      :text="modal.text"
      :spinner="modal.spinner"
      :request-error="modal.requestError"
      @hide="hideModals">
    </tm-modal>
    <vk-modal-confirm
      :show="modalConfirm.show"
      :text="modalConfirm.text"
      :icon="modalConfirm.icon"
      @hide="hideModals"
      @confirm="$broadcast('modal:confirmed')">
    </vk-modal-confirm>
    <products></products>
  </div>
</template>

<script>
import store from './vuex/store'
import Products from './components/Products'
import TmModal from './components/TmModal'
import Authentication from './components/Products/Authentication'

export default {
  components: {
    Products,
    TmModal,
    Authentication
  },
  store,
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    requestErrorVisible: false
  }),
  vuex: {
    getters: {
      modal: state => state.modal,
      modalConfirm: state => state.modalConfirm,
      modalAuth: state => state.products.authentication
    },
    actions: {
      initState ({ dispatch }, state) {
        dispatch('RECEIVE_INIT_STATE', state)
      },
      // workaround for altering the modal state
      // using mutations instead of two-way sync
      hideModals ({ dispatch }) {
        if (this.modalConfirm.show) {
          dispatch('HIDE_MODAL_CONFIRM')
        }
        if (this.modalAuth.show) {
          dispatch('HIDE_AUTH')
        }
        if (this.modal.show) {
          dispatch('HIDE_MODAL')
        }
      }
    }
  },
  created: function () {
    this.initState(this.state)
  }
}
</script>

<style>
.zl-am {
  margin: 15px;
}
.uk-modal-dialog .uk-modal-content {
  min-height: 40px;
}
</style>



/** WEBPACK FOOTER **
 ** App.vue?0405c124
 **/